import $ from 'jquery';

$(function () {
  var $table = $('.compare-range-table');
  var $prev = $('#prev');
  var $next = $('#next');
  var cellWidth = 270;
  var scrollAmount;
  var scrollRemainder;

  $prev.on('click', function () {
    $prev.attr('disabled', true);

    scrollRemainder = $table.scrollLeft() % cellWidth;

    if (scrollRemainder) {
      scrollAmount = scrollRemainder;
    } else {
      scrollAmount = cellWidth;
    }

    $table.animate(
      {
        scrollLeft: '-=' + scrollAmount + 'px',
      },
      300,
    );

    setTimeout(function () {
      $prev.attr('disabled', false);
    }, 300);
  });

  $next.on('click', function () {
    $next.attr('disabled', true);

    scrollRemainder = $table.scrollLeft() % cellWidth;

    if (scrollRemainder) {
      scrollAmount = cellWidth - scrollRemainder;
    } else {
      scrollAmount = cellWidth;
    }

    $table.animate(
      {
        scrollLeft: '+=' + scrollAmount + 'px',
      },
      300,
    );

    setTimeout(function () {
      $next.attr('disabled', false);
    }, 300);
  });

  const tables = [...document.querySelectorAll('.compare-range-table')];

  let observer;

  let options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  };

  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        setTimeout(function () {
          entry.target.classList.add('compare-range-table--visible');
        }, 600);
        observer.unobserve(entry.target);
      }
    });
  }, options);

  tables.forEach((table) => {
    observer.observe(table);
  });

  var $heading = $('.compare-range-heading').not('.compare-range-heading--current');
  var $product = $('.compare-range-product');
  var numberOfProducts = $product.length - 1;
  var productWidth;

  function headingWidth() {
    productWidth = $product.outerWidth();
    $heading.css('width', numberOfProducts * productWidth);
  }

  function getProductTitleMaxHeight() {
    const products = Array.from(document.querySelectorAll('.compare-range-product'));
    let maxHeight = 0;

    if (products.length <= 0) {
      return 0;
    }

    [...products].forEach((product) => {
      let heading = product.querySelector('h3');

      if (heading) {
        heading.style.minHeight = `auto`;

        let headingHeight = heading.clientHeight;

        if (headingHeight > maxHeight) {
          maxHeight = headingHeight;
        }
      }
    });

    return maxHeight;
  }

  function matchProductTitleHeight() {
    const maxHeight = getProductTitleMaxHeight();
    if (document.querySelectorAll('.compare-range-product').length) {
      [...document.querySelectorAll('.compare-range-product')].forEach((product) => {
        const heading = product.querySelector('h3');

        if (heading) {
          heading.style.minHeight = `${maxHeight}px`;
        }
      });
    }
  }

  function getProductPriceHeight() {
    const productPrice = document.querySelectorAll(
      '.compare-range-product .compare-range-price:not(.compare-range-price__placeholder)',
    )[0];

    if (productPrice) {
      return productPrice.clientHeight;
    }

    return 0;
  }

  function matchProductPricePlaceholderHeight() {
    const height = getProductPriceHeight();
    if (document.querySelectorAll('.compare-range-price__placeholder').length) {
      [...document.querySelectorAll('.compare-range-price__placeholder')].forEach((placeholder) => {
        placeholder.style.minHeight = `${height}px`;
      });
    }
  }

  headingWidth();
  matchProductTitleHeight();
  matchProductPricePlaceholderHeight();

  $(window).on('resize', function () {
    headingWidth();
    matchProductTitleHeight();
    matchProductPricePlaceholderHeight();
  });
});
